/**
 * Harvest quantity -> pool pounds, for SHOWING the user before they save.
 *
 * The twin of api/services/honey_units.py, and deliberately a twin rather
 * than the only copy: the server does the conversion that is written to
 * the ledger, always. This one exists so the dialog can say "that's about
 * 59 lb into the pool" while the user is still typing, because a beekeeper
 * entering 5 gallons has no reason to know what the app will bank -- and
 * finding out afterwards, from a balance that moved by an unexpected
 * number, is how people stop trusting the pool.
 *
 * If the two ever disagree, the server is right. Nothing here is sent.
 *
 * THE NUMBERS
 * Honey runs about 1.42 kg/L at 17-18% moisture -- roughly half again the
 * density of water, so anything reaching for water's 8.34 lb/gal is out
 * by 42%. From that one density:
 *
 *     Kg  -> 2.20462 lb
 *     L   -> 1.42 kg          = 3.131 lb
 *     Gal -> 3.78541 L (US)   = 11.85 lb
 *
 * 11.85 lb/gal is the figure printed on the side of a supplier's bucket,
 * which is the check that matters: disagree with that and the user is
 * right and the app is wrong. US gallons, not imperial -- an imperial
 * gallon would come out a fifth heavier, and the app has no locale
 * setting to choose between them.
 */
const LB_PER_KG = 2.20462;
const HONEY_KG_PER_LITRE = 1.42;
const LITRES_PER_US_GALLON = 3.78541;
const LB_PER_LITRE = HONEY_KG_PER_LITRE * LB_PER_KG;

export const TO_POUNDS = {
  Lbs: 1,
  Kg: LB_PER_KG,
  L: LB_PER_LITRE,
  Gal: LB_PER_LITRE * LITRES_PER_US_GALLON,
};

/** Pounds for a quantity, or null when there is nothing to convert yet. */
export function toPounds(quantity, unit) {
  const n = Number(quantity);
  const factor = TO_POUNDS[unit];
  // Returns null rather than 0 for an empty box: "0 lb" under a field the
  // user has not filled in reads like an answer, and this has none yet.
  if (!n || !factor) return null;
  return Math.round(n * factor * 100) / 100;
}
